import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { CoralResponse } from '../types';

interface ParentCoralSummaryProps {
  coral: CoralResponse;
}

const ParentCoralSummary: React.FC<ParentCoralSummaryProps> = ({ coral }) => (
  <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
    <Typography variant="h6" gutterBottom>
      Selected Parent Coral
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' },
        gap: 2,
      }}
    >
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          RFID
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          {coral.rfid || 'Untagged'}
        </Typography>
      </Stack>
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          Coral ID
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace', overflowWrap: 'anywhere' }}>
          {coral.coralId}
        </Typography>
      </Stack>
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          Species Code
        </Typography>
        <Typography variant="body2">{coral.speciesCode}</Typography>
      </Stack>
      <Stack spacing={0.25} alignItems={{ xs: 'flex-start', md: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          Status
        </Typography>
        <Chip size="small" label={coral.status} />
      </Stack>
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          Cut Date
        </Typography>
        <Typography variant="body2">{coral.cutDate || '-'}</Typography>
      </Stack>
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
      Child metadata is entered independently and is not inherited from the parent.
    </Typography>
  </Paper>
);

export default ParentCoralSummary;
